import ArchiveBody from './ArchiveBody';

export default ArchiveBody;
